import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { InnovationsProvider as Provider } from '../../components/context/innovations-context';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const QUERY = graphql`
query NodeAllInnovationsQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Innovations" } }) {
    nodes {
      data
    }
  }
}
`;

export const InnovationsProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(QUERY), 'items')}>{children}</Provider>;
};
